import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';

import Button from '../Button/Button';
import InputField from '../InputField/InputField';
import SelectOptions from '../SelectOptions/SelectOptions';
// import SelectUserPermission from '../SelectUserPermission/SelectUserPermission';
import ListSelectUserPermissions from '../ListSelectUserPermissions/ListSelectUserPermissions';

// import CheckIcon from '../../assets/svgs/CheckIcon';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import onlyNumbers from '../../utils/onlyNumbers';

import PlusIcon from '../../assets/svgs/PlusIcon';

import { AddUserFormStyle } from './AddUserFormStyle';
import { cpfMask } from '../../utils/cpfMask';
import { telMask } from '../../utils/telMask';

const AddUserForm = ({
  editUserData,
  isOpenAddUserForm,
  setIsOpenAddUserForm,
  setLoading,
  setUserActionComplete,
  handleEditUserData,
}) => {
  const institution = useSelector((state) => state.settings.institution);
  const language = useSelector((state) => state.settings.language);
  
  const [cpfError, setCpfError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [hasUserDataForEditing, setHasUserDataForEditing] = useState(false);
  const [identification, setIdentification] = useState('');
  const [matriculation, setMatriculation] = useState('');
  const [matriculationError, setMatriculationError] = useState('');
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [role, setRole] = useState('');
  const [roleError, setRoleError] = useState('');
  const [userId, setUserId] = useState(0);
  
  const [userPermissions, setUserPermissions] = useState([]);
  const [ userPermissionsError, setUserPermissionsError] = useState('');

  const [listOfSelects, setListOfSelects] = useState([uuidV4()]);

  const [permissionList, setPermissionList] = useState([]);

  useEffect(() => {
    if (editUserData?.id) {
      setUserId(editUserData.id);
      setHasUserDataForEditing(true);
      setRole(editUserData.type);
      setIdentification(editUserData.cpf);
      setMatriculation(editUserData.inscription);
      setPhoneNumber(editUserData.phone);
      setName(editUserData.name);
      setEmail(editUserData.email);

      if (editUserData?.permissions_data_formated?.length) {
        setUserPermissions(editUserData.permissions_data_formated);
        setListOfSelects(editUserData.permissions_data_formated);
      }

      Api.getInstitutionsAndPermissions()
        .then((response) => {
          if (response?.data) {
            setPermissionList(
              response?.data?.avaliable_to_doc_and_tec?.permissions
            );
          }
        })
        .catch((error) => error);
    } else {
      setHasUserDataForEditing(false);
    }
  }, [editUserData, institution]);

  const closeForm = () => {
    if (handleEditUserData) {
      handleEditUserData(null);
    }

    setIsOpenAddUserForm('');
    setUserId('');
    setHasUserDataForEditing(false);
    setRole('');
    setIdentification('');
    setMatriculation('');
    setPhoneNumber('');
    setName('');
    setEmail('');
    setUserPermissions([]);
    setRoleError('');
    setMatriculationError('');
    setCpfError('');
    setNameError('');
    setUserPermissions([]);
  };

  const handleAddNewRegister = () => {
    if (!role) {
      return setRoleError('thisFieldIsRequired');
    } else {
      setRoleError('')
    }

    if (!matriculation) {
      return setMatriculationError('thisFieldIsRequired');
    } else {
      setMatriculationError('')
    }

    if (!identification) {
      return setCpfError('thisFieldIsRequired');
    } else {
      const cpfValidation = onlyNumbers(identification);
      if (!cpfValidation.length === 11) {
        setCpfError('cpfMustBeValid');
      } else {
        setCpfError('');
      }
    }

    if (!name) {
      return setNameError('thisFieldIsRequired');
    } else {
      setNameError('')
      }

    if (!email) {
      return setEmailError('thisFieldIsRequired');
    } else {
      setEmailError('')
      }

    if (identification) {
    }
    if (userPermissions.length == 0) {
      return setUserPermissionsError('thisFieldIsRequired');

    }

    setLoading(true);
    const user = {
      name,
      email,
      password: 'healthScanUserRegister',
      generate_password: true,
      accepts_usage_terms: true,
      accepts_privacy_policy: true,
      inscription: onlyNumbers(matriculation),

      type: role,
      cpf: onlyNumbers(identification),
      phone: onlyNumbers(phoneNumber),
    };

    Api.registerUser(user)
      .then((res) => {
        if (res?.data?.id) {
          const postUserPermission = {
            // institutions: usersInstitutions,
            user: res.data.id,
            institutions: userPermissions,
          };

          Api.postInstitutionAndPermissionUser(postUserPermission).then(
            (response) => {
              if (response.status === 200) {
                setUserActionComplete({
                  type: 'success',
                  text: 'Usuário adicionado com sucesso',
                });
              } else {
                setUserActionComplete({
                  type: 'error',
                  text: 'Ocorreu um erro ao cadastrar as permissões do usuário',
                });
              }
            }
          );

          closeForm();
        }

        if (res.status === 400) {
          if (res.data?.cpf) {
            setCpfError('cpfMustBeValid');
          }

          if (res.data?.email) {
            setEmailError('theEmailMustBeValid');
          }
        }
      })
      .finally(() => setLoading(false));

    return false;
  };

  const handleChangeSelect = (value, options, setValue) => {
    const currentOption = options.find(
      (option) => `${option.value}` === `${value}`
    );

    if (currentOption) {
      setValue(currentOption.value);
    }
  };

  const handleDeleteSelectPermission = (selectId, institutionIdSelected) => {
    const newUserPermission = userPermissions.filter(
      (institutionItem) => institutionItem.id !== institutionIdSelected
    );
    setUserPermissions(newUserPermission);

    const selectArrayIDs = [...listOfSelects];
    selectArrayIDs.splice(selectArrayIDs.indexOf(selectId), 1);
    return setListOfSelects(selectArrayIDs);
  };

  const handleEditUser = (id) => {
    if (!role) {
      return setRoleError('thisFieldIsRequired');
    }
    const newPermission = [];

    setLoading(true);
    const data = {
      name,
      type: role,
      phone: phoneNumber,
      cpf: identification,
      accepts_usage_terms: true,
      accepts_privacy_policy: true,
      permissions: newPermission,
    };

    // const institutionPermissionArray = [];
    const currentPermissionArray = [];

    userPermissions.forEach((userPermission) => {
      permissionList.forEach((permissionItem) => {
        if (
          permissionItem.institution === userPermission.id &&
          userPermission.permissions.includes(permissionItem.permission)
        ) {
          currentPermissionArray.push(permissionItem.id);
        }
      });
    });

    const editPermission = {
      user: userId,
      institutions: userPermissions,
    };

    Api.postInstitutionAndPermissionUser(editPermission).then((response) => {
      if (response.status === 200) {
        Api.patchEditUser(id, data)
          .then((res) => {
            if (res.status === 200) {
              setUserActionComplete({
                type: 'success',
                text: 'Os dados do usuário foram alterados com sucesso',
              });
              closeForm();
            }

            if (res.status === 400) {
              if (res.data.type) {
                setRoleError('thisFieldIsRequired');
              }

              if (res.data.inscription) {
                setMatriculationError('thisFieldIsRequired');
              }

              if (res.data.cpf) {
                setCpfError('cpfAlreadyRegistered');
              }
            }
          })
          .finally(() => setLoading(false));
      } else if (response.status === 403) {
        setUserActionComplete({
          type: 'error',
          text: 'Não foi possível atualizar a permissão',
        });
        closeForm();
      }
    });

    return false;
  };

  const handleAddSelectOfInstitution = (event) => {
    event.preventDefault();

    const newInstitution = [...listOfSelects];
    newInstitution.push(uuidV4());
    setListOfSelects(newInstitution);
  };

  return (
    <AddUserFormStyle>
      <div className={`add-user-form${isOpenAddUserForm}`}>
        <div className="title-header">
          <span className="title-form">
            {hasUserDataForEditing ? translate('addNewRegister', language) : translate('addNewRegister', language)}
          </span>
          <span className="subtitle-form">Personal Informations</span>
        </div>
        <button
          type="button"
          className="close-form-button"
          onClick={() => closeForm()}
        >
          +
        </button>
        <div className="inline-input-container">
          <div className="input-container">
            <p className="input-label">Role *</p>
            <SelectOptions
              theme="soft-blue-outline"
              name="role"
              id="role"
              options={[
                { key: 0, value: '', text: translate('selectUserType', language)},
                { key: 1, value: 'DOC', text: 'Doctor' },
                { key: 2, value: 'TEC', text: 'Technician' },
              ]}
              value={role}
              onChange={(value) =>
                handleChangeSelect(
                  value,
                  [
                    { key: 0, value: '', text: translate('selectUserType', language)},
                    { key: 1, value: 'DOC', text: 'Doctor' },
                    { key: 2, value: 'TEC', text: 'Technician' },
                  ],
                  setRole
                )
              }
            />
            {roleError ? (
              <p className="error-message">{translate(roleError, language)}</p>
            ) : null}
          </div>

          <div className="input-container">
            <p className="input-label">{translate('matriculation', language)} *</p>
            <InputField
              type="text"
              inputName="matriculation"
              value={matriculation}
              noMarginBottom
              onChange={setMatriculation}
              disabled={hasUserDataForEditing}
              placeholder={translate('insertMatriculation', language)}
            />
            {matriculationError ? (
              <p className="error-message">
                {translate(matriculationError, language)}
              </p>
            ) : null}
          </div>
        </div>
        <div className="input-container">
          <p className="input-label">{translate('name', language)} *</p>
          <InputField
            type="text"
            inputName="name"
            value={name}
            noMarginBottom
            onChange={setName}
            placeholder={translate('name', language)}
          />
          {nameError ? (
            <p className="error-message">{translate(nameError, language)}</p>
          ) : null}
        </div>
        <div className="inline-input-container">
          <div className="input-container">
            <p className="input-label">CPF *</p>
            <InputField
              type="text"
              inputName="identification"
              value={cpfMask(identification)}
              noMarginBottom
              onChange={setIdentification}
              placeholder="000.000.000-00"
            />
            {cpfError ? (
              <p className="error-message">{translate(cpfError, language)}</p>
            ) : null}
          </div>
          <div className="input-container">
            <p className="input-label">{translate('telephone', language)}</p>
            <InputField
              type="text"
              inputName="phone-number"
              value={telMask(phoneNumber)}
              noMarginBottom
              onChange={setPhoneNumber}
              placeholder="(00) 00000-0000"
            />
          </div>
        </div>
        <div className="input-container">
          <p className="input-label">E-mail *</p>
          <InputField
            type="text"
            inputName="email"
            value={email}
            noMarginBottom
            onChange={setEmail}
            disabled={hasUserDataForEditing}
            placeholder={translate('exampleEmail', language)}
          />
          {emailError ? (
            <p className="error-message">{translate(emailError, language)}</p>
          ) : null}
        </div>
        {/* {addSelectOfInstitutions.map(() => (
          <SelectUserPermission
            usersInstitutions={usersInstitutions}
            setUsersInstitutions={setUsersInstitutions}
            userPermissions={userPermissions}
            setUserPermissions={setUserPermissions}
            handleDeleteSelectPermission={handleDeleteSelectPermission}
          />
        ))} */}
        {listOfSelects.map((value) => (
          <ListSelectUserPermissions
            key={value?.id ? value?.id : value}
            selectId={value?.id ? value : null}
            userPermissions={userPermissions}
            setUserPermissions={setUserPermissions}
            handleDeleteSelectPermission={handleDeleteSelectPermission}
            hasUserDataForEdition={hasUserDataForEditing}
            multi_field_text = {translate('searchInstitutions', language)}
          />
        ))}
         {userPermissionsError ? (
              <p className="error-message">{translate('userPermissionsError', language)}</p>
            ) : null}
        <button
          type="button"
          className="add-new-institution"
          onClick={handleAddSelectOfInstitution}
        >
          <span className="plus-container">
            <PlusIcon />
          </span>{' '}
          <span className="text">{translate('addNewInstitution', language )}</span>
        </button>
        <div className="buttons-container">
          <div className="button-wrapper">
            <Button
              type="button"
              theme="default"
              onClick={() => closeForm()}
              text={translate('cancel', language)}
            />
          </div>
          <div className="button-wrapper">
            <Button
              type="button"
              theme="default"
              onClick={
                hasUserDataForEditing
                  ? () => handleEditUser(userId)
                  : handleAddNewRegister
              }
              text={hasUserDataForEditing ? translate('edit', language) : translate('add', language)}
            />
          </div>
        </div>
      </div>
    </AddUserFormStyle>
  );
};

AddUserForm.propTypes = {
  isOpenAddUserForm: PropTypes.string,
  setIsOpenAddUserForm: PropTypes.func.isRequired,
  editUserData: PropTypes.string,
  setUserActionComplete: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  handleEditUserData: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.func,
  ]),
  multi_field_text: PropTypes.string,
};

AddUserForm.defaultProps = {
  isOpenAddUserForm: '',
  editUserData: '',
  handleEditUserData: null,
};
export default AddUserForm;
